// Px rather than `em` to match the rest of the app's media queries — mixing the
// two gives two cutovers that drift apart when the browser font size changes.
export const MOBILE_BREAKPOINT = 768

// Stylesheets hardcode 767px, as CSS modules cannot read this value.
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`
